@if (vraag.isTextVraag()) {
  <mat-form-field>
    <mat-label>{{getTextVraag().getLabel()}}</mat-label>
    <input matInput
      [formControl]="control"
      type="text"
      [placeholder]="getTextVraag().getPlaceholder()"
      [required]="getTextVraag().isRequired()">
    @if (control.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
}

@if (vraag.isTextareaVraag()) {
  <mat-form-field>
    <mat-label>{{getTextAreaVraag().getLabel()}}</mat-label>
    <textarea matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="6"
      [formControl]="control"
      type="textarea"
      [placeholder]="getTextAreaVraag().getPlaceholder()"
      [required]="getTextAreaVraag().isRequired()"
      (keydown.enter)="$event.stopPropagation()">
    </textarea>
    @if (control.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
}

@if (vraag.isRadioVraag()) {
  <div
    class="radio">
    <div>{{getRadioVraag().getLabel()}}</div>
    <div class="radio-group">
      <mat-radio-group [name]="getRadioVraag().getId()"
        color="primary"
        [required]="getRadioVraag().isRequired()"
        [formControl]="control">
        @for (option of getRadioVraag().getOptions(); track option) {
          <mat-radio-button
            [value]="option.getId()">
            {{option.getLabel()}}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </div>
}

@if (vraag.isSelectVraag() && !control.disabled) {
  <mat-form-field
    class="select">
    <mat-label>{{getSelectVraag().getLabel()}}</mat-label>
    <mat-select [formControl]="control"
      [required]="getSelectVraag().isRequired()"
      [placeholder]="getSelectVraag().getPlaceholder()"
      [multiple]="getSelectVraag().isMulti()">
      <mat-select-trigger>
        {{getSelectedOptionsLabel()}}
      </mat-select-trigger>
      @for (option of getSelectVraag().getOptions(); track option) {
        <mat-option
          [value]="option.getId()">
          @if (option.hasIcoon()) {
            <span [ngClass]="option.getIcoon()"></span>
          }
          {{option.getLabel()}}
        </mat-option>
      }
    </mat-select>
    @if (control.hasError('required')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
}

@if (vraag.isSelectVraag() && control.disabled) {
  <mat-form-field>
    <mat-label>{{getSelectVraag().getLabel()}}</mat-label>
    <input matInput
      [formControl]="control"
      type="text"
      [placeholder]="getSelectVraag().getPlaceholder()"
      [required]="getSelectVraag().isRequired()">
  </mat-form-field>
}

@if (vraag.isVerkeerslichtVraag()) {
  <div
    class="verkeerslicht">
    <div>{{getVerkeerslichtVraag().getLabel()}}
      @if (getVerkeerslichtVraag().hasUitleg()) {
        <button
          type="button"
          mat-icon-button
          (click)="openUitleg(getVerkeerslichtVraag())">
          <mat-icon fontSet="material-icons-outlined">info</mat-icon>
        </button>
      }
    </div>
    <div class="radio-group">
      <mat-radio-group [name]="getVerkeerslichtVraag().getId()"
        color="primary"
        [required]="getVerkeerslichtVraag().isRequired()"
        [formControl]="control">
        <mat-radio-button value="groen">
          <img class="icon"
            [class.selected]="control.value === 'groen'"
            src="assets/verkeerslicht/groen.svg">
          </mat-radio-button>
          <mat-radio-button value="oranje">
            <img class="icon"
              [class.selected]="control.value === 'oranje'"
              src="assets/verkeerslicht/oranje.svg">
            </mat-radio-button>
            <mat-radio-button value="rood">
              <img class="icon"
                [class.selected]="control.value === 'rood'"
                src="assets/verkeerslicht/rood.svg">
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      }
